module.exports = __webpack_public_path__ + "img/accessible.72d0bdd1.svg";